(function ($) {
    Array.prototype.remove = function () {
        var what, a = arguments, L = a.length, ax;
        while (L && this.length) {
            what = a[--L];
            while ((ax = this.indexOf(what)) !== -1) {
                this.splice(ax, 1);
            }
        }
        return this;
    };

    var $search = {

        $param: {
            'keyword': '',
            'positions': '',
            'areas': '',
            'lang_tools': '',
            'prices': '',
            'paginate': 1,
        },
        $positions: [],
        $areas: [],
        $langTools: [],
        $prices: [],
        $uri: app_start_local_data.siteurl + '/experts/project-search/',
        $json: '',
        $html: '',
        $post_total: 0, // 検索結果の合計数
        $post_number: 0, // 取得した数
        $post_type: 0, // 0;更新, 1:継続
        $scroll: 0,
        $langToolsCheckContainer: $('.project-lang-tools-terms-js'),
        $priceCheckContainer: $('.project-price-terms-js'),
        $priceCheckSpContainer: $('.project-price-terms-sp-js'),
        $positionCheckContainer: $('.project-position-terms-js'),
        $areaCheckContainer: $('.project-area-terms-js'),
        $keywordContainer: $('.job-search-keyword-js'),
        $searchFormMainContainer: $('.search-form-main-container-js'),
        $searchResultContainer: $('.search-result-container-js'),
        $loadingClass: 'loading-jobs',
        $loadMore: $('.job-load-more-js'),
        $form: $('.search-form-js'),
        $formSp: $('.search-form-sp-js'),
        $searchNoLoadMore: $('.no-load-more-item-js'),
        setCheckbox: function () {

        },

        setSearchPost: function (loadMore) {
            var self = this;
            self.$searchFormMainContainer.addClass(self.$loadingClass);
            self.$searchResultContainer.addClass(self.$loadingClass);
            $.ajax(
                self.$uri,
                {
                    type: 'get',
                    data: {
                        'keyword': self.$param['keyword'],
                        'term': self.$param['term'],
                        'paginate': self.$param['paginate'],
                        'positions': self.$param['positions'],
                        'areas': self.$param['areas'],
                        'lang_tools': self.$param['lang_tools'],
                        'prices': self.$param['prices']
                    },
                    dataType: 'json'
                }
            )
                // 検索失敗時には、その旨をダイアログ表示
                .fail(function () {
                    // self.renderErrorResults();
                    self.$searchFormMainContainer.removeClass(self.$loadingClass);
                    self.$searchResultContainer.removeClass(self.$loadingClass);
                })
                // 検索成功時にはページに結果を反映
                .done(function (json) {
                    self.$json = json;
                    self.$post_total = json.post_total;
                    self.$post_number = json.post_number;
                    self.$html = ''
                    if (json.post_total > 0) {
                        for (var $i = 0; $i < json.posts.length; $i++) {
                            self.addPostMarkUp($i);
                        }
                        if (loadMore) {
                            $('.search-case-items').append(self.$html);
                            self.$loadMore.data('paged', parseInt(json.page_current) + 1)
                        } else {
                            $('.search-case-items').html(self.$html);
                            self.$loadMore.data('paged', 2)
                        }
                    } else {
                        self.renderNoResults();
                    }
                    if (json.page_remain <= 0) {
                        self.$loadMore.hide();
                        self.$searchNoLoadMore.css('display', 'flex');
                    } else {
                        self.$loadMore.show();
                        self.$searchNoLoadMore.hide();
                    }
                    self.$searchFormMainContainer.removeClass(self.$loadingClass);
                    self.$searchResultContainer.removeClass(self.$loadingClass);
                });
        },

        renderErrorResults: function () {
            // self.$postContainer.html('<div class="message">エラーが発生しました。</div>');
            // self.$catListContainer.removeClass('loading');
            // self.$postSearchForm.find('button').prop('disabled', false);
            // self.$footerContainer.removeClass('searching');
        },

        renderNoResults: function () {
            var self = this;
            $('.search-case-items').html('<div class="message">該当する求人情報が<br class="hide-on-pc">見つかりませんでした。</div>');
        },

        renderSearchResults: function ($i) {
            var self = this;
            if ($i < self.$post_number) {
                self.addPostMarkUp($i);
            } else {
                if (self.$post_type) {
                    self.$postContainer.append(self.$html);
                } else {
                    self.$postContainer.html(self.$html);
                }
                self.$html = '';
                var keywords = self.$json.keywords.join(',');
                keywords = (keywords) ? keywords + 'の' : '';
                self.$searchKeyword.text(keywords);
                self.$searchPostCount.text(self.$json.post_total);
                self.$catListContainer.removeClass('loading');
                self.$postSearchForm.find('button').prop('disabled', false);
                self.$scroll = 1;
            }
        },

        addPostMarkUp: function ($i) {
            var self = this;
            var post = self.$json.posts[$i];
            var markUp = '<div class="job-list">' +
                '<a href="' + post.permalink + '">' +
                '<div class="title" style="background-image: url(' + post.thumbNailImage + ')"><div>' +
                ' <div class="professions">' + post.position + '</div>' +
                '<div class="technology">' + post.main_technology + '</div>' +
                '</div></div>' +
                '<h4 class="job-title">' + post.project_title + '</h4>' +
                '<div class="technologies">' + post.technologies + '</div>' +
                '<div class="location"><span class="station">最寄駅 : </span><span class="station">' + post.closest_station + '</span></div>' +
                '<div class="price"><span class="unit-price-label">単価（税抜き）</span><span class="unit-price-value">' + post.project_price + '</span></div>' +
                '</a></div>';
            self.$html += markUp;
        },

        onChangeCheckbox: function () {
            // var self = this;
            // $('li.term input').click(function () {
            //     if ($(this).parent('li').hasClass('active')) {
            //         $(this).parent('li').removeClass('active');
            //     } else {
            //         $(this).parent('li').addClass('active');
            //         $('li.all').removeClass('active');
            //         $('li.all input').prop("checked", false);
            //     }
            //     self.onChangeInputTerm();
            // });
            // $('li.all input').click(function () {
            //     if ($(this).parent('li').hasClass('active')) {
            //         $(this).parent('li').removeClass('active');
            //     } else {
            //         $(this).parent('li').addClass('active');
            //         $('li.term').removeClass('active');
            //         $('li.term input').prop("checked", false);
            //     }
            //     self.onChangeInputTerm();
            // });

        },

        onChangeInputTerm: function () {
            // var self = this;
            // var value = '';
            // $('li.active').each(function (i) {
            //     var divide = (i > 0) ? ',' : '';
            //     var filter = $(this).data('filter');
            //     value += divide + filter;
            // });
            // $('input[name="term"]').val(value);
            // self.$param['keyword'] = $('input[name="keyword"]').val();
            // self.$param['term'] = $('input[name="term"]').val();
            // self.$param['paginate'] = 1;
            // self.$post_type = 0;
            // self.$footerContainer.addClass('searching');
            // self.setSearchPost();
            // self.trackPageview();
            // self.replaceSearchUri();
        },

        submitSearch: function () {
            // var self = this;
            // self.$postSearchForm.submit(function (e) {
            //     e.preventDefault(); // 二重送信を防止
            //     self.$postSearchForm.find('button').prop('disabled', true);
            //     self.$param['keyword'] = $('input[name="keyword"]').val();
            //     self.$param['term'] = $('input[name="term"]').val();
            //     self.$param['paginate'] = 1;
            //     self.$post_type = 0;
            //     self.$footerContainer.addClass('searching');
            //     self.setSearchPost();
            //     self.trackPageview();
            //     self.replaceSearchUri();
            // });
        },

        onScrollBottom: function () {
            // var self = this;
            // $(window).on('scroll', function () {
            //     if (self.$scroll) {
            //         var docHeight = $(document).height();
            //         var winHeight = $(window).height() + $(window).scrollTop();
            //         var position = (docHeight - winHeight) / docHeight;
            //         if (position < 0.008) {
            //             self.$scroll = 0;
            //             self.$param['paginate']++;
            //             if (self.$param['paginate'] <= self.$json.page_totale) {
            //                 self.$post_type = 1;
            //                 self.setSearchPost();
            //                 self.trackPageview();
            //                 self.replaceSearchUri();
            //             } else {
            //                 self.$scroll = 1;
            //                 self.$footerContainer.removeClass('searching');
            //             }
            //         }
            //     }
            // });
        },

        replaceSearchUri: function () {
            var self = this;
            var uri = '?keyword=' + self.$param['keyword'] + '&term=' + self.$param['term'] + '&paginate=' + self.$param['paginate'];
            window.history.replaceState(null, null, uri); // URL書き換え
        },

        trackPageview: function () {
            // var self = this;
            // var keyword = self.$param['keyword'];
            // var term = self.$param['term'];
            // var page = self.$param['paginate'];
            // // GAにトラッキング
            // dataLayer.push({
            //     'event': 'projectsSearch',
            //     'keyword': keyword,
            //     'term': term,
            //     'page': page,
            // });
        },
        makeQueryArgs: function () {
            var self = this;
            self.$param['keyword'] = self.$keywordContainer.val();
            self.$param['prices'] = self.$priceCheckContainer.val();
            self.$param['lang_tools'] = self.$langTools.join(',,,');
            self.$param['areas'] = self.$areas.join(',,,');
            self.$param['positions'] = self.$positions.join(',,,');
        },
        onload: function () {
            var self = this;
            self.$positionCheckContainer.find('input[type="checkbox"]').each(function (index, item) {
                if ($(item).is(':checked')) {
                    var slug = $(item).data('slug');
                    if (self.$positions.indexOf(slug) < 0) {
                        self.$positions.push(slug);
                    }
                }
            });
            self.$areaCheckContainer.find('input[type="checkbox"]').each(function (index, item) {
                if ($(item).is(':checked')) {
                    var slug = $(item).data('slug');
                    if (self.$areas.indexOf(slug) < 0) {
                        self.$areas.push(slug);
                    }
                }
            });
            self.$langToolsCheckContainer.find('input[type="checkbox"]').each(function (index, item) {
                if ($(item).is(':checked')) {
                    var slug = $(item).data('slug');
                    if (self.$langTools.indexOf(slug) < 0) {
                        self.$langTools.push(slug);
                    }
                }
            });
        },
        onChange: function () {
            var self = this;
            self.$positionCheckContainer.find('input[type="checkbox"]').on('change', function () {
                if ($(this).is(':checked')) {
                    self.$positions.push($(this).data('slug'));
                } else {
                    self.$positions.remove($(this).data('slug'));
                }
            });
            self.$areaCheckContainer.find('input[type="checkbox"]').on('change', function () {
                if ($(this).is(':checked')) {
                    self.$areas.push($(this).data('slug'));
                } else {
                    self.$areas.remove($(this).data('slug'));
                }
            });
            self.$langToolsCheckContainer.find('input[type="checkbox"]').on('change', function () {
                if ($(this).is(':checked')) {
                    self.$langTools.push($(this).data('slug'));
                } else {
                    self.$langTools.remove($(this).data('slug'));
                }
            });
        },
        int: function ($) {
            var self = this;
            // if (app_start_local_data.projects_archive > 0) {
            //     self.$footerContainer.addClass('searching');
            //     var param = location.search.substring(1).split('&');
            //     for (var i = 0; i < param.length; i++) {
            //         var value = param[i].split('=');
            //         self.$param[value[0]] = value[1];
            //     }
            //     $('input[name="keyword"]').val(decodeURI(self.$param['keyword']));
            //     $('input[name="term"]').val(decodeURI(self.$param['term']));
            //     self.setCheckbox();
            //     self.submitSearch();
            //     self.onScrollBottom();
            // }
            $('.project-search-js').on('click', function (e) {
                self.$searchFormMainContainer.addClass(self.$loadingClass);
                self.$searchResultContainer.addClass(self.$loadingClass);
                self.$form.submit();
            });
            $('.project-search-sp-js').on('click', function (e) {
                self.$searchFormMainContainer.addClass(self.$loadingClass);
                self.$searchResultContainer.addClass(self.$loadingClass);
                self.$formSp.submit();
            });

            self.$loadMore.on('click', function (e) {
                self.$param.paginate = $(this).data('paged');
                self.makeQueryArgs();
                self.setSearchPost(true);
            });
            $(window).on('load', function () {
                self.onload();
            });
            self.onChange();
        }
    };

    $(function () {
        $search.int($);
    });

}(jQuery));